/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Components;
    (function (Components) {
        var ApLabeledTextInputController = /** @class */ (function () {
            function ApLabeledTextInputController($element, $timeout, $transclude) {
                this.$element = $element;
                this.$timeout = $timeout;
                this.$transclude = $transclude;
            }
            // "any" is the defined type at this time
            ApLabeledTextInputController.prototype.$onChanges = function (changesObj) {
                var hasValue = function (property) { return changesObj[property] && changesObj[property].currentValue; };
                if (hasValue('readOnly')) {
                    this.isReadOnly = ap.Utilities.isTrueValue(changesObj.readOnly.currentValue);
                }
                if (hasValue('autoFocus')) {
                    this.selectInput();
                }
            };
            ApLabeledTextInputController.prototype.$onInit = function () {
                this.isReadOnly = ap.Utilities.isTrueValue(this.readOnly);
                this.required = ap.Utilities.isTrueValue(this.required);
                var rows = Number(this.rows);
                this.showTextArea = !ap.Utilities.isNullOrUndefined(this.rows) || rows > 1;
                this.hasText = this.$transclude.isSlotFilled('text');
                this.hasAddOn = this.$transclude.isSlotFilled('addOn');
                this.hasTranscludedContent = this.hasText || this.hasAddOn;
            };
            ApLabeledTextInputController.prototype.$postLink = function () {
                var _this = this;
                this.$element.on('keydown', function (event) { return _this.onKeyPress({ arg: event }); });
                this.$timeout(function () {
                    if (ap.Utilities.isTrueValue(_this.autoFocus)) {
                        _this.selectInput();
                    }
                });
            };
            ApLabeledTextInputController.prototype.onTextboxExit = function () {
                var result = !this.required || (this.required && !ap.Utilities.isNullOrWhitespace(this.model));
                this.cssClass = !result ? this.cssClass || 'has-error' : '';
                this.onChange({ arg: this.model });
            };
            ApLabeledTextInputController.prototype.selectInput = function () {
                var input = this.$element.find('input');
                input.focus().select();
            };
            ApLabeledTextInputController.$inject = [
                '$element',
                '$timeout',
                '$transclude'
            ];
            return ApLabeledTextInputController;
        }());
        Components.ApLabeledTextInputController = ApLabeledTextInputController;
        angular
            .module('app.Components')
            .controller('ApLabeledTextInputController', ApLabeledTextInputController);
    })(Components = app.Components || (app.Components = {}));
})(app || (app = {}));
